<div class="gravity-tag"
[ngClass]="{'emergency': emergency == idGravity, 'very-urgent': veryUrgent == idGravity, 'urgent': urgent == idGravity, 'little-urgent': littleUrgent == idGravity, 'not-urgent': notUrgent == idGravity, 'deceased': deceased == idGravity, 'white-patient': whitePatient == idGravity}">
    {{gravityName}}
</div>